// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer[data-v-7a9de5b4]{padding:28px;background:#fff;box-shadow:0 1px 6px rgba(80,179,237,.2);margin:12px;border-radius:8px;cursor:pointer;transition:.2s}.answer[data-v-7a9de5b4]:hover{transform:scale(1.01);box-shadow:0 1px 9px rgba(80,179,237,.4);transition:.3s}", ""]);
// Exports
module.exports = exports;
